import { render, staticRenderFns } from "./widgetCode.vue?vue&type=template&id=4fb58b94&scoped=true"
import script from "./widgetCode.vue?vue&type=script&lang=js"
export * from "./widgetCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb58b94",
  null
  
)

export default component.exports